var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorNowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 55,
    viewBox: "0 0 250 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4001 36.3298C73.8601 38.0598 72.2701 38.8398 70.2401 38.8398C65.9201 38.8398 63.1301 35.1598 63.1301 29.4598C63.1301 23.7598 65.9001 20.1698 70.3701 20.1698C72.0701 20.1698 73.5601 20.8598 74.7901 22.2298L74.9801 22.4398L76.1801 21.1098L76.0401 20.9398C75.3701 20.1498 73.4701 18.3198 70.3801 18.3198C64.7501 18.3198 61.1101 22.6898 61.1101 29.4498C61.1101 36.2098 64.7601 40.6698 70.1901 40.6698C72.7801 40.6698 74.8301 39.6898 76.6501 37.5798L76.8001 37.4098L75.6001 36.1198L75.4201 36.3298H75.4001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5101 18.3198C84.1501 18.3198 80.5601 22.7798 80.5601 29.4198C80.5601 36.0598 84.1601 40.6798 89.5101 40.6798C94.8601 40.6798 98.4301 36.1598 98.4301 29.4198C98.4301 22.6798 94.8401 18.3198 89.5101 18.3198ZM89.5101 38.8298C85.3101 38.8298 82.5901 35.1398 82.5901 29.4198C82.5901 23.6998 85.3101 20.1698 89.5101 20.1698C93.7101 20.1698 96.4001 23.7998 96.4001 29.4198C96.4001 35.0398 93.6301 38.8298 89.5101 38.8298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.95 18.71H104.97V40.29H116.64V38.51H106.95V18.71Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.03 18.3198C123.67 18.3198 120.08 22.7798 120.08 29.4198C120.08 36.0598 123.68 40.6798 129.03 40.6798C134.38 40.6798 137.95 36.1598 137.95 29.4198C137.95 22.6798 134.36 18.3198 129.03 18.3198ZM129.03 38.8298C124.83 38.8298 122.11 35.1398 122.11 29.4198C122.11 23.6998 124.83 20.1698 129.03 20.1698C133.23 20.1698 135.92 23.7998 135.92 29.4198C135.92 35.0398 133.15 38.8298 129.03 38.8298Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.95 24.5202C157.95 20.6602 155.53 18.7002 150.76 18.7002H144.49V40.2902H146.46V30.5902H150.55L156.25 40.2902H158.53L152.7 30.4402C156.05 29.8602 157.95 27.7202 157.95 24.5202ZM146.46 20.4502H150.37C154.25 20.4502 155.91 21.6702 155.91 24.5202C155.91 27.3702 154.05 28.8802 150.37 28.8802H146.46V20.4502Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.32 31.8802C177.32 33.6702 177.39 35.4702 177.48 37.2402L175.45 33.7002L166.51 18.7002H164.58V40.2902H166.46V26.9502C166.46 25.1702 166.39 23.4902 166.31 21.7502L168.34 25.2902L177.28 40.2902H179.21V18.7002H177.33V31.8802H177.32Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.69 18.3198C189.33 18.3198 185.74 22.7798 185.74 29.4198C185.74 36.0598 189.34 40.6798 194.69 40.6798C200.04 40.6798 203.61 36.1598 203.61 29.4198C203.61 22.6798 200.02 18.3198 194.69 18.3198ZM194.69 38.8298C190.49 38.8298 187.77 35.1398 187.77 29.4198C187.77 23.6998 190.49 20.1698 194.69 20.1698C198.89 20.1698 201.58 23.7998 201.58 29.4198C201.58 35.0398 198.81 38.8298 194.69 38.8298Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.83 18.71L226.16 31.33C225.92 32.47 225.69 33.61 225.46 34.74C225.28 35.62 225.1 36.51 224.92 37.39C224.71 36.52 224.5 35.65 224.28 34.78C224 33.63 223.72 32.48 223.44 31.31L220.06 18.71H218.2L214.82 31.32C214.67 31.94 214.53 32.55 214.38 33.17C214.05 34.55 213.71 35.96 213.4 37.36L213.33 37.03C212.93 35.14 212.53 33.23 212.1 31.32L209.43 18.71H207.35L212.26 40.3H214.29L218.12 25.64C218.28 24.94 218.45 24.28 218.62 23.62C218.78 22.99 218.95 22.34 219.1 21.66C219.22 22.19 219.35 22.71 219.47 23.23C219.66 24.01 219.84 24.8 220.04 25.65L223.93 40.3H225.95L230.8 18.71H228.81H228.83Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.42 19.3199H234.21V18.6899H237.37V19.3199H236.16V22.8799H235.42V19.3199Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.54 18.6899H239.35L240.11 20.7499L240.39 21.5399H240.42L240.7 20.7499L241.44 18.6899H242.26V22.8799H241.56V20.9599C241.56 20.5699 241.62 20.0099 241.66 19.6299H241.63L241.29 20.5899L240.57 22.4899H240.23L239.51 20.5899L239.18 19.6299H239.15C239.18 20.0099 239.24 20.5699 239.24 20.9599V22.8799H238.56V18.6899H238.54Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7016 43.6222L51.4316 42.7466L40.6097 33.7237L39.8796 34.5992L50.7016 43.6222Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7438 47.2543L47.6472 46.5591L39.0542 35.3927L38.1507 36.088L46.7438 47.2543Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0826 49.935L43.116 49.4536L37.1657 36.6817L36.1324 37.1631L42.0826 49.935Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9502 51.5403L38.0637 51.2959L35.0429 37.5335L33.9294 37.7779L36.9502 51.5403Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5856 51.9844L32.7256 51.9888L32.7797 37.8989L31.6397 37.8945L31.5856 51.9844Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2659 51.2505L27.3774 51.5034L30.5039 37.7647L29.3923 37.5117L26.2659 51.2505Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2255 49.373L22.2551 49.8623L28.3033 37.1364L27.2736 36.6471L21.2255 49.373Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7284 46.4438L17.6265 47.146L26.305 36.046L25.4069 35.3438L16.7284 46.4438Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9596 42.6008L13.6829 43.4819L24.5738 34.5424L23.8505 33.6612L12.9596 42.6008Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1358 38.0238L10.6494 39.0415L23.2282 32.693L22.7145 31.6753L10.1358 38.0238Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37161 32.946L8.65088 34.0513L22.3116 30.5997L22.0323 29.4944L8.37161 32.946Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75812 27.5987L7.78955 28.7383L21.8742 28.3498L21.8428 27.2102L7.75812 27.5987Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31557 22.2502L8.09766 23.3691L21.9278 26.0625L22.1458 24.9435L8.31557 22.2502Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0495 17.1537L9.59277 18.1982L22.5024 23.8437L22.9591 22.7992L10.0495 17.1537Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8296 12.5554L12.156 13.4751L23.5232 21.8007L24.1968 20.881L12.8296 12.5554Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5536 8.68494L15.6956 9.43555L24.9728 20.0403L25.8308 19.2897L16.5536 8.68494Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0411 5.71392L20.04 6.25928L26.7805 18.6324L27.7816 18.0871L21.0411 5.71392Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0603 3.79407L24.9644 4.10791L28.8434 17.6534L29.9393 17.3396L26.0603 3.79407Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3834 3.00994L30.2454 3.07715L31.0761 17.1426L32.2141 17.0754L31.3834 3.00994Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7422 3.40531L35.6169 3.22266L33.3594 17.1306L34.4846 17.3133L36.7422 3.40531Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.894 4.9667L40.8357 4.54297L35.5986 17.6235L36.6569 18.0472L41.894 4.9667Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.57 7.60972L45.6296 6.96533L37.6652 18.5884L38.6056 19.2328L46.57 7.60972Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5582 11.209L49.781 10.375L39.4729 19.9808L40.2501 20.8148L50.5582 11.209Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6713 15.5972L53.0947 14.6138L40.9394 21.7395L41.516 22.723L53.6713 15.5972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorNowWhite);
export default __webpack_public_path__ + "static/media/colorNowWhite.78d23b13b583bbeb3bd5e0a393ef4af8.svg";
export { ForwardRef as ReactComponent };